import { put } from "redux-saga/effects";
import { API } from 'aws-amplify';
import { getResponseData } from '../../utils/apiHelpers';

import * as actions from "../actions";
import { handleApiError } from '../../utils/apiErrorHandler';

export function* getTakeCardsSaga(action) {
    try {
        let apiName = 'API_Aktiwiteite';
        let path = `/take`;
        const response = yield API.get(apiName, path, { response: true });
        // console.log(response);
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            yield put(actions.getTakeCardsFailed({ status: 204 }, "Geen data kon gevind word nie", 204, ""));
        } else {
            yield put(actions.setTakeCards(getResponseData(response, [])));
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getTakeCardsFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* getTakeCardsPerLaneSaga(action) {
    try {
        if (action.lazy) {
            yield put(actions.setTakeCardsPerLaneLazyLoading(action.lane));
        }
        let apiName = 'API_Aktiwiteite';
        let path = `/take?status=${action.lane}&pagination=true&limit=${action.limit || 20}&lastindex=${action.lastindex}&lastid=${action.lastid}`;
        const response = yield API.get(apiName, path, { response: true });
        // console.log(response);
        let result = [];
        if (response.status !== 204 && getResponseData(response, []).length > 0) {
            result = getResponseData(response, []);
        }
        if (action.lazy) {
            yield put(actions.setTakeCardsPerLaneLazy(result, action.lane));
        } else {
            yield put(actions.setTakeCardsPerLane(result, action.lane));
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getTakeCardsFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message, action.lane));
    }
}

export function* stelTaakIndexSaga(action) {
    try {
        yield put(actions.setTakeCardsPerLaneLazyLoading(action.lane));
        yield put(actions.setClearTaakIndexFailed());
        let body = {
            ouindexes: action.ouindexes,
            indexes: action.indexes
        };
        if (action.status.id) {
            body = {
                ...body,
                status: action.status
            }
        }
        let apiName = 'API_Aktiwiteite';
        let path = `/take/skuif`;
        let myInit = {
            response: true,
            body: body
        }
        yield API.put(apiName, path, myInit);
        if (action.status.id) {
            yield put(actions.setTakeCardsPerLaneLazyLoading(action.status.status));
            yield put(actions.setTakeCardsPerLaneLazyLoading(action.status.oustatus));
            yield put(actions.initKryTakeCardsPerLane(action.status.status, null, false, action.status.vanitemcount));
            yield put(actions.initKryTakeCardsPerLane(action.status.oustatus, null, false, action.status.naitemcount));
        } else {
            yield put(actions.setTakeCardsPerLaneLazyLoading(action.lane));
            yield put(actions.initKryTakeCardsPerLane(action.lane, null, false, action.itemcount));
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.setTaakIndexFailed(errordata, "Orde en/of status kon nie verander word nie", errordata.code, errordata.message));
    }
}